import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IConclusion, IManDay, IPhase} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectManDays = api.injectEndpoints({
  endpoints: builder => ({
    getProjectManDays: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/man-days`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<IManDay>>;

export const {useGetProjectManDaysQuery} = getProjectManDays;
